/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_auth_no_account = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Don't have an account? Sign up`)
};

const es_auth_no_account = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿No tienes cuenta? Regístrate`)
};

const de_auth_no_account = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch kein Konto? Registrieren`)
};

const nl_auth_no_account = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geen account? Registreren`)
};

const fr_auth_no_account = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pas de compte ? S’inscrire`)
};

const it_auth_no_account = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non hai un account? Registrati`)
};

const pt_br2_auth_no_account = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não tem conta? Cadastre-se`)
};

const pt_auth_no_account = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não tem conta? Registe-se`)
};

const ja_auth_no_account = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アカウントをお持ちでない方は登録`)
};

const zh_auth_no_account = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`没有账户？立即注册`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const auth_no_account = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.auth_no_account(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("auth_no_account", locale)
	if (locale === "en") return en_auth_no_account(inputs)
	if (locale === "es") return es_auth_no_account(inputs)
	if (locale === "de") return de_auth_no_account(inputs)
	if (locale === "nl") return nl_auth_no_account(inputs)
	if (locale === "fr") return fr_auth_no_account(inputs)
	if (locale === "it") return it_auth_no_account(inputs)
	if (locale === "pt-BR") return pt_br2_auth_no_account(inputs)
	if (locale === "pt") return pt_auth_no_account(inputs)
	if (locale === "ja") return ja_auth_no_account(inputs)
	return zh_auth_no_account(inputs)
};